<template>
    <div class="content">
        <div class="container-fluid mt-7">
            <div class="card pb-2">
                <div class="row">
                    <div class="col-12 text-right">
                        <button class="btn btn-link" @click="redirect">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                </div>
                <div class="card-header border-0 pt-0">
                    <div class="row">
                        <div class="col-6 pb-2">
                            <h3 class="mb-0">Variations</h3>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6 mb-2 mb-sm-4 ">
                        <div class="card ml-md-4 h-100 ">
                            <variation-card cardClass="card-pricing border-0 mb-4" headerClass="bg-teal"
                                buttonClass="bg-teal border-0" header="Execution variables"
                                :features="executionVariables" iconClass="bg-white text-primary" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6 mb-2 mb-sm-4">
                        <div class="card mr-md-4 h-100">
                            <variation-card cardClass="card-pricing border-0 mb-4" headerClass="bg-info"
                                buttonClass="bg-info border-0" header="Stock variables" :features="stockVariables"
                                iconClass="bg-white text-info" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6 mb-2 mb-sm-4">
                        <div class="card ml-md-4 h-100">
                            <variation-card cardClass="card-pricing border-0 mb-4"
                                headerClass="text-white strategy-header" buttonClass="strategy-header border-0"
                                header="Strategy variables" :features="strategyVariables"
                                iconClass="bg-white text-strategy" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6 mb-2 mb-sm-4">
                        <div class="card mr-md-4 h-100">
                            <variation-card cardClass="card-pricing border-0 mb-4" headerClass="variation-header"
                                buttonClass="variation-header border-0" header="Filter variables"
                                :features="filterVariables" iconClass="bg-white text-header" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import VariationCard from "./VariationCard.vue";
export default {
    name: "Variation",
    components: {
        VariationCard,
    },
    data() {
        return {
            executionVariables: '',
            strategyVariables: '',
            filterVariables: '',
            stockVariables: '',
            variationId: '',
        };
    },
    methods: {
        getVariations(variationId, type, variationType) {
            let data = {
                variationId: variationId,
                type: type,
            };
            this.$store.dispatch("variationStore/getVariationDetails", data, { root: true })
                .then(response => {
                    if (variationType === 'executionVariables') {
                        this.executionVariables = response.server.data.variables;
                    } else if (variationType === 'strategyVariables') {
                        this.strategyVariables = response.server.data.variables;
                    } else if (variationType === 'filterVariables') {
                        this.filterVariables = response.server.data.variables;
                    } else if (variationType === 'stockVariables') {
                        this.stockVariables = response.server.data.variables;
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        redirect() {
            this.$router.push({ path: '/system/portfolios' });
        }
    },
    mounted() {
        this.variationId = sessionStorage.getItem('variationId');
        this.getVariations(this.variationId, 'EXECUTION', 'executionVariables');
        this.getVariations(this.variationId, 'STRATEGY', 'strategyVariables');
        this.getVariations(this.variationId, 'FILTER', 'filterVariables');
        this.getVariations(this.variationId, 'STOCK', 'stockVariables');
    },
};
</script>
